import { SCHOOL_MEAL_CUSTOMER_TYPES } from 'common/constants';
import type { Client } from 'modules/account/types';

/** API response for GET HVS info - mirrors HvsInfo schema */
export interface HVSInfoModel {
  '@context': string;
  '@id': string;
  '@type': string;
  operationCode: string;
  name: string;
  phone: string;
  email: string;
  website: string;
  wardName: string;
  districtName: string;
  cityName: string;
  addressDetail: string;
  longitude: string;
  latitude: string;
  [key: string]: unknown;
}

export type MapDialogKey =
  | 'schoolInfo'
  | 'dailyDish'
  | 'nutritionMenu'
  | 'teacherNutritionMenu'
  | 'dailyInvoice'
  | 'balanceMenu'
  | 'foodTraceability';

/** Client from kios with map UI extensions */
export interface ClientModel extends Client {
  index: number;
  activeKey?: MapDialogKey;
}

export type WeekdayAlias = '2' | '3' | '4' | '5' | '6';

export interface MMapNutritionMenuModel {
  searchStr: string;
  structuredData: {
    data: {
      info: {
        title: string;
        weekTitle: string;
      };
      items: Array<{
        dishes: string[];
        weekDay: 2 | 3 | 4 | 5 | 6;
        datetime: string;
        afternoons: string[][];
      }>;
    };
    metadata: {
      fromDate: string;
      toDate: string;
      isUsed: boolean;
    };
  };
  metadata: {
    v20241121: {
      day: number;
      week: number;
      year: number;
      month: number;
      state: string;
    };
  };
  parentId: string;
  type: string;
  deletedAt: string | null;
  updatedAt: string;
}

export type ClientNutritionMenuModel = MMapNutritionMenuModel[];

export interface FilterModel {
  search?: string;
  customerType?: string;
  cityId?: number | string;
  wardId?: number | string;
}

export const CustomerTypeOptions = [
  // { id: "MN", name: "Mầm non" },
  { id: 'TH', name: 'Tiểu học' },
  { id: 'THCS', name: 'THCS' },
  { id: 'THPT', name: 'THPT' },
  { id: 'PTCS', name: 'PTCS' },
  // { id: "CQNN", name: "Cơ quan nhà nước" },
];

/**
 * Phân loại khách hàng được hiển thị trên BẢN ĐỒ THỰC ĐƠN (GMAP): chỉ suất ăn cấp 1, 2.
 * Mầm non (MN) chỉ cung cấp thực phẩm, Cơ quan nhà nước (CQNN) và KHAC không có thực đơn
 * → KHÔNG lên GMAP. Dashboard-UM, Quick Search và QR NCC TPAT (FSOL) vẫn dùng TẤT CẢ khách
 * hàng nên không áp bộ lọc này (các màn đó lấy dữ liệu bằng hook riêng).
 *
 * Lấy từ `SCHOOL_MEAL_CUSTOMER_TYPES` (common/constants) vì màn Mã xác nhận cũng lọc trường theo
 * đúng nhóm này — một nguồn duy nhất để hai màn không lệch. `CustomerTypeOptions` ở trên là
 * options CÓ NHÃN cho dropdown lọc của GMAP, id phải trùng danh sách dùng chung đó.
 */
export const GMAP_CUSTOMER_TYPES = SCHOOL_MEAL_CUSTOMER_TYPES;
